export let AccountantAccess;

(function (AccountantAccess) {
  AccountantAccess["NonCandidate"] = "nonCandidate";
  AccountantAccess["Candidate"] = "candidate";
  AccountantAccess["Invited"] = "invited";
  AccountantAccess["Active"] = "active";
})(AccountantAccess || (AccountantAccess = {}));

export let EditMode;

(function (EditMode) {
  EditMode["Editable"] = "editable";
  EditMode["Readonly"] = "readonly";
})(EditMode || (EditMode = {}));